module.exports = __webpack_public_path__ + "static/media/logo_short_dark.c907ac01.svg";